import { JSX } from 'react'

import { IconProps } from '../../icon'

const Projects: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 49 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M36.5013 14.9256H29.0144C28.1278 14.9256 27.3397 14.3674 27.0605 13.53L26.9128 13.0867C26.2889 11.2478 24.5813 10 22.6275 10H18.4243C15.9287 10 13.9092 12.0195 13.9092 14.5151V27.6501C13.9092 30.1457 15.9287 32.1652 18.4243 32.1652H36.4849C38.9805 32.1652 41 30.1457 41 27.6501V19.4407C41 16.9451 38.9805 14.9256 36.4849 14.9256H36.5013ZM38.5536 27.6501C38.5536 28.783 37.6342 29.7024 36.5013 29.7024H18.4407C17.3078 29.7024 16.3884 28.783 16.3884 27.6501V14.5151C16.3884 13.3822 17.3078 12.4628 18.4407 12.4628H22.6439C23.5305 12.4628 24.3186 13.021 24.5977 13.8584L24.7455 14.3017C25.3694 16.1406 27.077 17.3884 29.0308 17.3884H36.5177C37.6506 17.3884 38.57 18.3078 38.57 19.4407V27.6501H38.5536Z'
      fill='black'
    />
    <path
      d='M34.8594 34.628H15.157C13.1211 34.628 11.4628 32.9697 11.4628 30.9338V16.157C11.4628 15.4838 10.9046 14.9256 10.2314 14.9256C9.55823 14.9256 9 15.4838 9 16.157V30.9338C9 34.3325 11.7583 37.0908 15.157 37.0908H34.8594C35.5326 37.0908 36.0908 36.5326 36.0908 35.8594C36.0908 35.1862 35.5326 34.628 34.8594 34.628Z'
      fill='black'
    />
  </svg>
)

export default Projects
